export const SYSTEM_SPECIAL_LEVEL = 25;

export const SYSTEM_SCENIC_MAPS = [];


function positiveInt(
  value,
  fallback = 1
) {
  const number =
    Math.floor(
      Number(value)
    );

  return number > 0
    ? number
    : fallback;
}


function normalizeFragment(
  fragment
) {
  return {
    fragmentCode:
      String(
        fragment?.fragment_code
        ?? fragment?.fragmentCode
        ?? ""
      ),

    level:
      positiveInt(
        fragment?.level_no
        ?? fragment?.level,
        0
      ),

    pieceIndex:
      Math.max(
        0,
        Math.floor(
          Number(
            fragment?.piece_index
            ?? fragment?.pieceIndex
            ?? 0
          )
        )
      ),

    acquired:
      fragment?.acquired === true
  };
}


function normalizeMap(
  map,
  index
) {
  const rows =
    positiveInt(
      map?.rows
    );

  const columns =
    positiveInt(
      map?.columns
      ?? map?.cols
    );

  const fragments =
    Array.isArray(
      map?.fragments
    )
      ? map.fragments
          .map(
            normalizeFragment
          )
          .filter(
            fragment =>
              fragment.level > 0
              && fragment.fragmentCode
          )
          .sort(
            (
              left,
              right
            ) =>
              left.pieceIndex
              - right.pieceIndex
          )
      : [];

  const levels =
    fragments.map(
      fragment =>
        fragment.level
    );

  const mapCode =
    String(
      map?.map_code
      ?? map?.mapCode
      ?? map?.id
      ?? `scenic-${index + 1}`
    );

  return {
    id: mapCode,
    mapCode,

    name:
      String(
        map?.name
        ?? mapCode
      ),

    image:
      String(
        map?.image_url
        ?? map?.image
        ?? ""
      ),

    outline:
      String(
        map?.outline_url
        ?? map?.outline
        ?? ""
      ),

    rows,
    columns,

    pieceCount:
      positiveInt(
        map?.piece_count,
        rows * columns
      ),

    startLevel:
      levels.length
        ? Math.min(...levels)
        : 0,

    endLevel:
      levels.length
        ? Math.max(...levels)
        : 0,

    fragments,

    pieceOrder:
      fragments.map(
        fragment =>
          fragment.pieceIndex
      ),

    fragmentCodes:
      fragments.map(
        fragment =>
          fragment.fragmentCode
      )
  };
}


export function setSystemScenicMaps(
  maps = []
) {
  const normalized =
    Array.isArray(maps)
      ? maps.map(
          normalizeMap
        )
      : [];

  SYSTEM_SCENIC_MAPS.splice(
    0,
    SYSTEM_SCENIC_MAPS.length,
    ...normalized
  );

  return getSystemScenicMaps();
}


export function getSystemScenicMaps() {
  return SYSTEM_SCENIC_MAPS.map(
    scenic => ({
      ...scenic,

      fragments:
        scenic.fragments.map(
          fragment => ({
            ...fragment
          })
        ),

      pieceOrder: [
        ...scenic.pieceOrder
      ],

      fragmentCodes: [
        ...scenic.fragmentCodes
      ]
    })
  );
}


export function getScenicMapForLevel(
  level
) {
  const target =
    Number(level);

  return (
    SYSTEM_SCENIC_MAPS.find(
      scenic =>
        scenic.fragments.some(
          fragment =>
            fragment.level
            === target
        )
    )
    || null
  );
}


export function getScenicPieceIndex(
  level
) {
  const scenic =
    getScenicMapForLevel(
      level
    );

  if (!scenic) {
    return -1;
  }

  return (
    scenic.fragments.find(
      fragment =>
        fragment.level
        === Number(level)
    )
      ?.pieceIndex
    ?? -1
  );
}


export function getScenicLevelForPiece(
  scenic,
  pieceIndex
) {
  if (!scenic) {
    return null;
  }

  return (
    scenic.fragments?.find(
      fragment =>
        fragment.pieceIndex
        === Number(pieceIndex)
    )
      ?.level
    ?? null
  );
}


export function getScenicFragmentCodeForLevel(
  level
) {
  const scenic =
    getScenicMapForLevel(
      level
    );

  if (!scenic) {
    return null;
  }

  return (
    scenic.fragments.find(
      fragment =>
        fragment.level
        === Number(level)
    )
      ?.fragmentCode
    ?? null
  );
}


export function getScenicFragmentCodeForPiece(
  scenic,
  pieceIndex
) {
  if (!scenic) {
    return null;
  }

  return (
    scenic.fragments?.find(
      fragment =>
        fragment.pieceIndex
        === Number(pieceIndex)
    )
      ?.fragmentCode
    ?? null
  );
}
